// src/pages/in-kind/RequestService.js
import InKindServiceForm from "../../components/InKindServiceForm";

function RequestService() {
  return <InKindServiceForm contributionType="need" />;
}

export default RequestService;